export default __webpack_public_path__ + "static/media/line-v-09.a74750fd.png";